import e from "react";
import { formatPrice as m } from "./index110.mjs";
import { RoomInput as x } from "./index226.mjs";
const g = ({ salesTerms: n, includedService: l, isDisabled: t }) => /* @__PURE__ */ e.createElement("div", { className: "font-semibold" }, /* @__PURE__ */ e.createElement(
  "span",
  {
    className: n.cancellable ? t ? "text-success-30" : "text-success-60" : t ? "text-neutrals-40" : "text-neutrals-70"
  },
  n.modifiable ? I18n.t("booking_engine.results.rate.modifiable") : I18n.t("booking_engine.results.rate.non_modifiable"),
  "."
), /* @__PURE__ */ e.createElement(
  "span",
  {
    className: n.cancellable ? t ? "text-success-30" : "text-success-60" : t ? "text-neutrals-40" : "text-neutrals-70"
  },
  " ",
  n.cancellable ? I18n.t("booking_engine.results.rate.cancellable") : I18n.t("booking_engine.results.rate.non_cancellable"),
  "."
), l ? /* @__PURE__ */ e.createElement("span", { className: t ? "text-success-30" : "text-success-60" }, " ", I18n.t(
  `booking_engine.results.rate.included_service.${l}`
), ".") : null, n.insurance_eligible ? /* @__PURE__ */ e.createElement("span", { className: t ? "text-success-30" : "text-success-60" }, " ", I18n.t("booking_engine.room.insurance_available"), ".") : null), _ = ({
  rate: n,
  currency: l,
  isDisabled: t,
  handleDisabledClick: o,
  handleOnChange: r,
  roomAmount: s,
  openTerms: c,
  noOfRooms: i,
  children: u
}) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: `flex flex-col gap-2.5 rounded-lg p-3 ${t ? "bg-white" : "bg-neutrals-10"}`
  },
  /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `text-base font-semibold ${t ? "text-neutrals-40" : "text-neutrals-90"}`
    },
    n.name
  ),
  /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `flex flex-col text-xs leading-[18px] ${t ? "text-neutrals-40" : "text-neutrals-70"}`
    },
    /* @__PURE__ */ e.createElement(
      g,
      {
        salesTerms: n.sales_term,
        includedService: n.included_service,
        isDisabled: t
      }
    ),
    /* @__PURE__ */ e.createElement("div", null, m(parseFloat(n.price_per_day), l, !0), "/", " ", I18n.t("general.night")),
    n.additional_charges ? /* @__PURE__ */ e.createElement("div", null, I18n.t("booking_engine.information.additional_charges")) : null
  ),
  /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `cursor-pointer text-left text-xs font-medium ${t ? "text-primary-30" : "text-primary-60"} focus-visible:outline-primary border-none bg-transparent p-0 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2`,
      onClick: () => c(),
      role: "button",
      tabIndex: 0,
      "aria-label": I18n.t(
        "booking_engine.accessibility.view_terms_and_conditions"
      ),
      onKeyDown: (a) => {
        (a.key === "Enter" || a.key === " ") && (a.preventDefault(), c());
      }
    },
    I18n.t("booking_engine.information.terms_and_conditions")
  ),
  /* @__PURE__ */ e.createElement("div", { className: "flex items-center justify-between" }, /* @__PURE__ */ e.createElement("div", { className: "flex items-center gap-1" }, u), /* @__PURE__ */ e.createElement(
    x,
    {
      value: s,
      onChange: r,
      disabled: t,
      onDisabledClick: o,
      maxAmount: i
    }
  ))
);
export {
  _ as RateTile
};
